import { useQuery } from '@tanstack/react-query'
import { tenantsApi } from '@/api/tenants'

export function useMyTenants({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['tenants', 'mine'] as const,
    queryFn: () => tenantsApi.getMine(),
    enabled,
  })
}
